import React, { useState } from "react";

import { POINTS_ADMIN } from "../../../config/lang";
import { translate } from "../../../util/util";

// A simple editor for a JSON object field: rows of { label -> value } that the
// user can add/remove. The stored value is a plain object { key: value }.
const toRows = v =>
  v && typeof v === "object" && !Array.isArray(v)
    ? Object.entries(v).map(([key, value]) => ({ key, value: value == null ? "" : String(value) }))
    : [];

const toObject = rows =>
  rows.reduce((o, r) => {
    const k = r.key.trim();
    if (k) o[k] = r.value;
    return o;
  }, {});

export default function KeyValueField({ field, value, onChange, lang }) {
  const [rows, setRows] = useState(() => toRows(value));

  const sync = next => {
    setRows(next);
    onChange(field.name, toObject(next));
  };
  const update = (i, key, val) => sync(rows.map((r, idx) => (idx === i ? { ...r, [key]: val } : r)));
  const add = () => setRows([...rows, { key: "", value: "" }]);
  const remove = i => sync(rows.filter((_, idx) => idx !== i));

  return (
    <div className="pt-form-group">
      <label className="pt-form-label">{field._label}</label>
      <div className="pt-kv">
        {rows.map((row, i) => (
          <div className="pt-kv-row" key={i}>
            <input
              className="mp-form-input"
              placeholder={translate(POINTS_ADMIN, "kv_key", lang)}
              value={row.key}
              onChange={e => update(i, "key", e.target.value)}
            />
            <input
              className="mp-form-input"
              placeholder={translate(POINTS_ADMIN, "kv_value", lang)}
              value={row.value}
              onChange={e => update(i, "value", e.target.value)}
            />
            <button type="button" className="pt-kv-remove" aria-label="remove" onClick={() => remove(i)}>
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
        ))}
        <button type="button" className="pt-kv-add" onClick={add}>
          <span className="material-symbols-outlined">add</span>
          {translate(POINTS_ADMIN, "kv_add", lang)}
        </button>
      </div>
    </div>
  );
}
